'use strict'

class CampaignFormCtrl {

    constructor ($http, $rootScope, $scope, moment, $state, $stateParams, Campaign, $mdDialog, $mdToast, itemData, $sce, Item, $timeout, $transitions) {

        // Dependencies
        this.$http = $http
        this.$moment = moment
        this.oldUrl = ''
        this.$mdDialog = $mdDialog
        this.$stateParams = $stateParams
        this.today = moment().format('YYYY-MM-DD')
        this.$mdToast = $mdToast
        this.itemData = itemData
        this.$scope = $scope
        this.$sce = $sce
        this.$timeout = $timeout

        this.$state = $state
        this._Campaign = Campaign
        this._Item = Item
        this.doNotWarn = false

        this.items = []
        this.itemCount = 0
        this.itemCustomFieldsRaw = []
        this.customFieldsRaw = []
        this.customFields = {}

        this.setEmptyCampaign()

        // Watchers
        $scope.$on('$destroy', () => {
            this.unregisterStateChangeStart()
        })

        this.unregisterStateChangeStart = $transitions.onStart({}, this.stateChangeStart.bind(this))

        $rootScope.checkActive = (campaign) => {
            return campaign.id == $stateParams.id
        }

        $scope.$on('campaign_save_schedule', this.onScheduleSave.bind(this))

        itemData.subscribe('campaign', this.$scope, () => {
            this.formdata.item = angular.extend({}, this.itemData.getItemObj())
        })

        this.getCampaignData()
    }

    setEmptyCampaign () {
        this.formdataCopy = null
        this.formdata = {
            item: {},
            recommended: true,
            startTime: '00:00:00',
            stopTime: '00:00:00',
        }
    }

    getCampaignData () {
        this.setEmptyCampaign()

        this.getModelTypes().then(() => {
            if (this.customFieldsRaw.length < 2) {
                this.formdata.model_type_id = this.customFieldsRaw[0].id
            }

            if (this.$stateParams.id) {
                this._Campaign.get({ id: this.$stateParams.id }, (data) => {

                    delete data.$promise

                    angular.extend(this.formdata, data)
                    this.formdata.model_type_id = data.model_type_id
                    this.fixDates()

                    this.itemData.setItemObj(this.formdata.item)
                    this.itemData.notify('item')

                    //Copy dataform so we can reverse the data on cancel
                    this.formdataCopy = angular.copy(this.formdata)
                })

                this.fetchItems(this.$stateParams.id)
            } else {
                // default type
                this.itemData.setItemObj({})
                this.formdata.model_type_id = this.customFieldsRaw[0].id
            }
        })
    }

    getModelTypes () {
        // We need these for scheme
        this.$http.get('/modeltypes/item', { cache: true }).then((response) => {
            this.itemCustomFieldsRaw = response.data.item
            this.formdata.item_model_type = this.itemCustomFieldsRaw[0].id
        })
        return this.$http.get('/modeltypes/campaign', { cache: true }).then((response) => {
            this.customFieldsRaw = response.data.campaign
            response.data.campaign.forEach((data) => {
                this.customFields[data.id] = data.fields
            })
            return response.data
        })
    }

    onScheduleSave (scope, data) {
        this.formdata.added_items = data.add_items.slice()
        this.formdata.removed_items = data.remove_items.slice()
    }

    //this date transform the custom date to 'new Date' so it can be re-used
    makeDate (date) {
        return date ? new Date(date) : new Date()
    }

    cancel () {
        this.$state.go('campaign')
    }

    save ($valid) {

        if (!$valid) {
            return
        }
        let modelData = angular.copy(this.formdata)

        modelData.description = this.formdata.description

        //map the ids from contacts instead of whole contact object
        if (this.formdata.item.contacts) {
            modelData.item.contacts = this.formdata.item.contacts.map((contact) => {
                return contact.id
            })
        }

        modelData.start = moment(moment(this.formdata.startDay).format('YYYY-MM-DD') + ' ' + this.formdata.startTime, 'YYYY-MM-DD HH:mm:ss')
        modelData.stop = moment(moment(this.formdata.stopDay).format('YYYY-MM-DD') + ' ' + this.formdata.stopTime, 'YYYY-MM-DD HH:mm:ss')

        //check if dates are not before mindate and each other
        if (moment(modelData.stop).isBefore(modelData.start)) {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.error?title=action_stop_before_start_date',
                hideDelay: 3000,
                position: ('top right')
            })
            return
        }

        if (modelData.items) {
            delete modelData.items
        }

        if (modelData.item_count) {
            delete modelData.item_count
        }

        this.buttonDisabled = true

        //Disable not save reminder confirm box
        this.doNotWarn = true

        this._Campaign.save(modelData, (data) => {

            if (this.formdata.id) {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.saved?object=campaign&title=' + this.formdata.title, //@trans('labels.campaign')
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.$state.go('campaign.update', { id: this.formdata.id }, { 'reload': true })

            } else {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.create?object=campaign&title=' + this.formdata.title, //@trans('labels.campaign')
                    hideDelay: 3000,
                    position: ('top right')
                })

                //temporary go to update because of the schema items bug
                this.$state.go('campaign.update', { id: data.id }, { 'reload': true })
            }

            //remove item object from service
            this.itemData.setItemObj({})
        })
    }

    fixDates () {
        const { formdata } = this

        if (formdata.start) {
            formdata.startDay = new Date(formdata.start)
            formdata.startTime = moment(formdata.startDay).format('HH:mm:ss')
        }

        if (formdata.stop) {
            formdata.stopDay = new Date(formdata.stop)
            formdata.stopTime = moment(formdata.stopDay).format('HH:mm:ss')
        }
    }

    fetchItems (campaignId) {
        this.$http.get('items/campaign/' + campaignId).then((response) => {
            this.items = response.data
            this.stationId = window.CONFIG.station_id
        })
    }

    deleteItem (id, title, index, ev) {
        ev.stopPropagation()

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            this._Item.delete({ id: id }, () => {
                this.items.splice(index, 1)
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=item&title=' + title, //@trans('labels.campaign')
                    hideDelay: 6000,
                    position: ('top right')
                })
            })
        })
    }

    get hours () {

        var hours = []

        for (let i = 0; i < 24; i++) {

            let format = (i < 10) ? '0' + i : i

            format += ':00'

            hours.push(format)
        }

        return hours
    }

    showRevisions (ev) {

        this.$http.get('/revisions/campaigns/' + this.$stateParams.id).then(revisions => {

            this.$mdDialog.show({

                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    revisions: revisions.data
                }
            }).then(values => {
                this.formdata.title = values.title
                this.formdata.model_type_id = values.model_type_id
                this.formdata.startDay = moment(values.start).format('YYYY-MM-DD')
                this.formdata.stopDay = moment(values.stop).format('YYYY-MM-DD')
                this.formdata.startTime = moment(values.start).format('HH:mm:ss')
                this.formdata.stopTime = moment(values.stop).format('HH:mm:ss')

                this.formdata.item = values.item
                this.itemData.setItemObj(values.item)
                this.itemData.notify('item')

                this.formdata.recommended = values.recommended
                this.formdata.description = values.description
            }).catch(error => {
                console.error(error)
            })
        })
    }

    sanitizeHtml (text) {
        return this.$sce.trustAsHtml(text)
    }

    stateChangeStart (transition) {

        let to = transition.to()
        let from = transition.from()
        let toParams = transition.params()

        if (
            to.url === '/schedule' || to.url === '/item' || to.url === '/contact/:contactId' ||
            ((to.url === '/update/:id' || to.url === '/create') && from.url === '/schedule')
        ) {
            return
        }

        if (this.formdata.title) {

            let checkFormData = Object.assign({}, this.formdata)

            //Dirty Timezone fix, the campaign date created error is fixed here
            checkFormData.start = moment(moment(checkFormData.startDay).format('YYYY-MM-DD') + ' ' + checkFormData.startTime, 'YYYY-MM-DD HH:mm:ss')
            checkFormData.stop = moment(moment(checkFormData.stopDay).format('YYYY-MM-DD') + ' ' + checkFormData.stopTime, 'YYYY-MM-DD HH:mm:ss')
            if (this.formdataCopy) {
                this.formdataCopy.start = moment(moment(this.formdataCopy.startDay).format('YYYY-MM-DD') + ' ' + this.formdataCopy.startTime, 'YYYY-MM-DD HH:mm:ss')
                this.formdataCopy.stop = moment(moment(this.formdataCopy.stopDay).format('YYYY-MM-DD') + ' ' + this.formdataCopy.stopTime, 'YYYY-MM-DD HH:mm:ss')
            }

            let formDataCopy = this.formdataCopy

            if (formDataCopy && formDataCopy.field_values) {
                this.fixFieldValuesValues(checkFormData.field_values)
            }

            if (formDataCopy && formDataCopy.field_values) {
                this.fixFieldValuesValues(formDataCopy.field_values)
            }

            let checkNew = JSON.stringify(checkFormData)
            let checkOld = JSON.stringify(formDataCopy)

            if (checkNew !== checkOld && !this.doNotWarn) {

                //Stop changing state
                transition.abort()

                this.$mdDialog.show({
                    controller: 'ConfirmDialogCtrl',
                    templateUrl: 'unsavedDataDialog.ngTemplate',
                    parent: angular.element(document.querySelector('#popupContainer')),
                    clickOutsideToClose: true
                }).then(() => {

                    this.doNotWarn = true
                    this.$state.go(to, toParams)
                }).catch(() => {

                })
            }
        }
    }

    fixFieldValuesValues (obj) {
        if (obj && obj instanceof Object) {
            for (const key in obj) {
                if (!obj.hasOwnProperty(key)) continue

                if (obj[key] instanceof Date) {
                    obj[key] = obj[key].toISOString()
                }
            }
        }
    }

}

CampaignFormCtrl.$inject = ['$http', '$rootScope', '$scope', 'moment', '$state', '$stateParams', 'Campaign', '$mdDialog', '$mdToast', 'itemData', '$sce', 'Item', '$timeout', '$transitions']

module.exports = CampaignFormCtrl
